import { useLayoutEffect } from 'react'
import { useLocation, useNavigationType } from 'react-router-dom'

/**
 * Resets window scroll to the top on tab/link navigation. `BrowserRouter` does
 * not reset or restore scroll, so without this each tab inherited the previous
 * page's scroll offset (the "lands at weird spots between tabs" clunkiness).
 *
 * - Keyed on `pathname` only, so in-page search-param updates (e.g. BuildPage
 *   stripping `?commander=` on mount) don't jump the page.
 * - Skips `POP` so the browser back/forward buttons keep their restored scroll.
 * - Skips when a hash anchor is present so `#section` links still work.
 *
 * `useLayoutEffect` runs before paint, so there is no flash of the old offset.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation()
  const navType = useNavigationType()
  useLayoutEffect(() => {
    if (navType === 'POP' || hash) return
    window.scrollTo(0, 0)
    // navType/hash are read fresh each run; only pathname should re-trigger.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname])
  return null
}
